module.exports = __webpack_public_path__ + "img/Bonfida.d319c1e8.svg";